export default "__VITE_ASSET__BA94kU6Z__"